import React, { useEffect, useState } from 'react'; //import React Component
import { cloudStore } from '../firebase';
import { updateDoc, doc } from 'firebase/firestore';
import { NavLink } from 'react-router-dom';
export function CreateCard(props) {
    const productGenres = [
        "速食米饭",
        "速食火锅",
        "肉食",
        "速食汤面",
        "休闲零食",
        "饮料",
        "手工甜点",
    ];

    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    const [data, setdata] = useState([])
    useEffect(() => {
        if (props.filterContent.length > 0 && props.filterContent !== "All" && productGenres.includes(props.filterContent)) {
            let array = props.carddata.filter((content) => {
                return content["Product_Information"]["tag"] === props.filterContent
            })
            setdata(array)
        } else if (!productGenres.includes(props.filterContent) && props.filterContent !== "All" && props.filterContent.length > 0) {
            let array = props.carddata.filter((content) => {
                return productGenres.every(element =>
                    content["Product_Information"]["tag"] !== element
                );
            })
            setdata(array)
        } else {
            setdata(props.carddata);
        }
    }, [props.filterContent, props.carddata])

    const addItem = (e) => {
        const value = e.target.dataset.value;
        const clickedButton = e.target
        let forStock = JSON.parse(sessionStorage.getItem("forStock")).filter((content) => {
            return Object.keys(content).some((key) => key === value);
        })
        let forStocknum = 0
        if (forStock.length > 0) {
            forStocknum = forStock[0][value]
        }
        let compareData = props.carddata.filter((content) => {
            return content["Product_Information"]["proname"] === (value);
        })
        let compareDataStock = compareData[0].LeftNum
        // console.log("forStocknum: ", forStocknum)
        // console.log("compareDataStock: ", compareDataStock)
        if (forStocknum + 1 > compareDataStock) {
            console.log("达到库存上限")
            var tips = document.getElementById("snackbar");
            tips.className = "show";
            setTimeout(() => { tips.className = tips.className.replace("show", "disappearFade"); }, 2000);
        } else {
            clickedButton.classList.add("cart2")
            clickedButton.textContent = 'Add';
            setTimeout(() => { clickedButton.classList.remove("cart2") }, 500);
            setTimeout(() => { clickedButton.textContent = 'add_shopping_cart'; }, 500);

            if (value.length > 0) {
                if (sessionStorage.getItem("WhatInCart")) {
                    let array = JSON.parse(sessionStorage.getItem("WhatInCart"));
                    array.push(value);
                    sessionStorage.setItem("WhatInCart", JSON.stringify(array));
                } else {
                    sessionStorage.setItem("WhatInCart", JSON.stringify([value]));
                }
            }

            const cartUpdateEvent = new CustomEvent("cartUpdated");
            window.dispatchEvent(cartUpdateEvent);
        }
    }

    let newEachCard = null
    if (data.length > 0) {
        newEachCard = data.map((content) => {
            let pic = content["Product_Information"]["pic"]
            // let prointro = content["Product_Information"]["prointro"]
            let proname = content["Product_Information"]["proname"]
            let proprice = content["Product_Information"]["proprice"]
            // let tag = content["Product_Information"]["tag"]
            // let author = content["Product_Information"]["author"]
            // let support = content["Support"]
            // let sell = content["Sell"]
            let left = content["LeftNum"]
            let ifOnFire = content["OnFire"]
            let ifoffShelves = content["offShelves"]
            let proID = content["Product_Information"]["proID"]

            let firebutton = "nothing"
            if (ifOnFire) {
                firebutton = "fire2"
            }

            let offShelvesbutton1 = "nothing"
            let offShelvesbutton2 = "nothing"
            if (ifoffShelves) {
                offShelvesbutton1 = "offShelvesbutton1"
                offShelvesbutton2 = "offShelvesbutton2"
            }


            if (left === 0 && !ifoffShelves) {
                const fetchData = async () => {
                    await updateDoc(doc(cloudStore, "productData", proID), { "offShelves": true })
                }
                fetchData();
            }

            return (
                <div className="card" key={proname}>
                    <div className="card_img">
                        <div className={"blockimg " + offShelvesbutton1}>已下架</div>
                        <img
                            src={pic}
                            alt="pro_img"
                            key={proname}
                        />
                    </div>

                    <NavLink to={"/Food/" + proname} draggable={false}><div className={'forClick ' + offShelvesbutton2} onClick={topFunction}></div></NavLink>
                    <div className={'fire ' + firebutton}>
                        <span className="material-symbols-outlined">
                            local_fire_department
                        </span>
                    </div>
                    <div className="card_content">
                        <div>
                            <h2>{proname} </h2>
                            <h3>价格：{proprice} $</h3>
                            <h3>库存：{left} 件</h3>
                        </div>
                    </div>
                    <div
                        className={'cartButton material-symbols-outlined ' + offShelvesbutton2}
                        data-value={proname}
                        onClick={(e) => addItem(e)}
                        style={{ animation: "none" }}>
                        add_shopping_cart
                    </div>
                    <div id="snackbar">抱歉，已达库存上限。</div>
                </div >
            )
        })
    }

    return (
        <div className="cards" style={{paddingTop:"0"}}>
            {newEachCard}
        </div>
    );
}